<template>


    <div class="ec-nav-panel-icons">
<!--        <router-link-->
<!--            :to="{name: ! auth.isLoggedIn() ? 'login' :'cart_items.index', params: { lang : $i18n.locale  }}"-->
<!--                     class="toggle-cart ec-header-btn ec-side-toggle">-->
<!--            <i class="fi-rr-shopping-basket"></i>-->
<!--            <span class="ec-cart-noti ec-header-count cart-count-lable">{{ cartItems.length }}</span>-->
<!--        </router-link>-->
        <a href="#" class="toggle-cart ec-header-btn ec-side-toggle">
            <i class="fi-rr-shopping-basket"></i>
            <span class="ec-cart-noti ec-header-count cart-count-lable">{{ cartItems.length }}</span>
        </a>
    </div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['auth'],
    computed: {
        ...mapGetters(['cartItems']), // Map the cartItems getter
        subtotal() {
            return parseFloat(
                this.cartItems.reduce((subtotal, product) => subtotal + (product?.cart?.quantity || 0) * product.price, 0)
            ).toFixed(2);
        },
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart']), // Map the addToCart and removeFromCart actions
        // Your other methods here
    },
};

</script>

<style scoped>
/* Add your component-specific styles here */
</style>
